import BaseAccountController from '../../lib/controllers/BaseAccountController';
import queryParameterParser from '../../lib/helpers/queryStringParser';

declare var LtFramework: lt.Static;

export default class ActivateAccountController extends BaseAccountController {
	public static $inject: string[] = ['$scope', '$window', 'navigationService', 'UserAccountResource'];

	public loading = true;
	public generalError: string;
	public generalMessage: string;

	private readonly navigationService: INavigationService;
	private readonly UserAccount: MyAccountApi.IUserAccountResource;

	constructor($scope: ng.IScope, $window: ng.IWindowService, navigationService: INavigationService,
			UserAccountResource: MyAccountApi.IUserAccountResource) {
		super($scope);

		this.navigationService = navigationService;
		this.UserAccount = UserAccountResource;

		const activationKey = queryParameterParser.getParameterByName($window, 'activationKey');
		const partyId = queryParameterParser.getParameterByName($window, 'partyId');

		this.activateAccount(activationKey || '', partyId || '');
	}

	// Activates an account given an activation key and party ID.
	// Redirects to the login page if successful, or shows an error message if not.
	private activateAccount(activationKey: string, partyId: string): void {
		this.UserAccount.activate({activationKey, partyId}, (resp: MyAccountApi.IUserAccountCreatedResponse) => {
			this.navigationService.requestNavigation('global.accountLogin').catch((err: Error) => {
				this.loading = false;
				this.generalError = 'Unable to redirect: ' + err.message;
			});
		}, (failure: MyAccountApi.IServiceFailureResponse) => {
			this.loading = false;

			if (failure && failure.data && failure.data.validationErrors) {
				this.generalError = failure.data.validationErrors[0].message;
			} else {
				this.generalError = 'Server error while activating account';
			}
		});
	}
}
